module.exports = __webpack_public_path__ + "static/media/medellin-16.ab9f09d0.jpg";